import { render, staticRenderFns } from "./ListContas.vue?vue&type=template&id=1858c5dd&"
import script from "./ListContas.vue?vue&type=script&lang=js&"
export * from "./ListContas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports